export const HISTORY_LAST_SEEN_KEY = 'omakase-unshi:history-last-seen';

/**
 * issue #84: Drive 履歴を最後に閲覧した時刻 (epoch ms)。
 * 未設定 / 壊れた値は 0 を返す (初回は全件「新着」扱い、 実害小)。
 */
export function getHistoryLastSeen(): number {
  if (typeof window === 'undefined') return 0;
  const raw = window.localStorage.getItem(HISTORY_LAST_SEEN_KEY);
  if (!raw) return 0;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

/** 省略時は現在時刻 (Date.now) を保存する。 */
export function setHistoryLastSeen(ts?: number): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(HISTORY_LAST_SEEN_KEY, String(ts ?? Date.now()));
}
